// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-granth-seller-address-labels',
//   standalone: true,
//   imports: [],
  // templateUrl: './granth-seller-address-labels.component.html',
  // styleUrl: './granth-seller-address-labels.component.scss'
// })
// export class GranthSellerAddressLabelsComponent {

// }
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-granth-seller-address-labels',
  templateUrl: './granth-seller-address-labels.component.html',
  styleUrl: './granth-seller-address-labels.component.scss'
})
export class GranthSellerAddressLabelsComponent implements OnInit {

  labelsData: any[] = [];
  data1: any[] = [];

  repNames        = '';
  district        = '';
  taluka          = '';
  deliveryMode    = '';
  distributiveRep = '';
  stateName       = '';
  iscustomer      = 'no';

  constructor(
    private dialogref: MatDialogRef<GranthSellerAddressLabelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.log('📥 RAW DIALOG DATA =>', this.data);

    // ✅ Support both wrapper key formats
    this.labelsData = Array.isArray(this.data?.addresslabels)
      ? this.data.addresslabels
      : Array.isArray(this.data)
        ? this.data          // ← in case raw array is passed directly
        : [];

    this.repNames        = this.data?.rep_names        ?? '';
    this.district        = this.data?.district_name    ?? '';
    this.taluka          = this.data?.taluka_name       ?? '';
    this.deliveryMode    = this.data?.delivery_mode     ?? '';
    this.distributiveRep = this.data?.distributive_reps ?? '';
    this.stateName       = this.data?.state_name        ?? '';
    this.iscustomer      = this.data?.iscustomer        ?? 'no';

    console.log('📦 labelsData received =>', this.labelsData);
    this.prepareData();
  }

  prepareData(): void {
    debugger
    if (!this.labelsData || this.labelsData.length === 0) {
      this.data1 = [];
      console.warn('⚠️ labelsData is empty — nothing to display');
      return;
    }

    this.data1 = this.labelsData.map((item: any, index: number) => {
      console.log(`ROW ${index}:`, item);

      // ✅ address: keep empty string if blank — don't hide the card
      const address = (item?.address ?? '').toString().trim();

      return {
        bse_id:      item?.bse_id      ?? '',
        name:        item?.name
                     ?? item?.bookseller_name
                     ?? item?.seller_name
                     ?? item?.title
                     ?? 'N/A',
        address:     address || '',          // empty string — template handles display
        district:    (item?.district    ?? '').toString().trim(),
        taluka:      (item?.taluka      ?? '').toString().trim(),
        state:       (item?.state       ?? '').toString().trim(),
        pincode:     (item?.pincode     ?? '').toString().trim(),
        mobile_no:   (item?.mobile_no   ?? '').toString().trim(),
        subno:       item?.subno        ?? '',
        month:       item?.month        ?? '',
        year:        item?.year         ?? '',
        book_copies: Number(item?.book_copies ?? 0),
        book_names:  item?.book_names   ?? '',
        sellertype:  item?.sellertype   ?? '',
        rep_name:    item?.rep_name     ?? '',
        DistributiveRep: item?.DistributiveRep ?? '',
      };
    });

    console.log('✅ FINAL DATA1 =>', this.data1);
  }

 printLabels(): void {
  if (!this.data1 || this.data1.length === 0) {
    alert('No data to print.');
    return;
  }

  // Build header lines
  const headerLines: string[] = [];
  if (this.repNames)       headerLines.push(`<div><b>प्रतिनिधी:</b> ${this.repNames}</div>`);
  if (this.distributiveRep) headerLines.push(`<div><b>वितरण प्रतिनिधी:</b> ${this.distributiveRep}</div>`);
  if (this.district)       headerLines.push(`<div><b>जिल्हा:</b> ${this.district}</div>`);
  if (this.taluka)         headerLines.push(`<div><b>तालुका:</b> ${this.taluka}</div>`);
  if (this.deliveryMode)   headerLines.push(`<div><b>वितरण पद्धत:</b> ${this.deliveryMode}</div>`);

  // Build label cards — 4 per row, each with page-break-inside:avoid
  const labelCards = this.data1.map((item: any) => {
    const district = item.district || '';
    const pincode  = item.pincode  ? ` - ${item.pincode}` : '';
    const state    = item.state    ? ` ${item.state}`      : '';
    const taluka   = item.taluka   ? `<div>${item.taluka}</div>` : '';
    const distLine = (district || pincode || state)
      ? `<div>${district}${pincode}${state}</div>` : '';

    return `
      <div style="
        width: 22%;
        border: 1px solid #000;
        padding: 8px 10px;
        font-size: 13px;
        box-sizing: border-box;
        page-break-inside: avoid;
        break-inside: avoid;
        overflow: hidden;
      ">
        <div style="display:flex; justify-content:space-between; font-weight:bold; margin-bottom:4px;">
          <span>${item.name || ''}</span>
          <span>${item.book_copies || ''}</span>
        </div>
        <div>${item.address || ''}</div>
        ${taluka}
        ${distLine}
      </div>`;
  }).join('');

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>पत्ता लेबल</title>
  <style>
    @page {
      size: A4 landscape;
      margin: 1cm;
    }
    * {
      font-family: 'Noto Sans Devanagari', Arial, sans-serif;
      box-sizing: border-box;
    }
    body {
      margin: 0;
      padding: 0;
      background: #fff;
    }
    .header {
      font-weight: bold;
      margin-bottom: 12px;
      font-size: 13px;
    }
    .label-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      width: 100%;
    }
    @media print {
      .label-grid {
        /* Allow natural page breaks between rows only */
        break-inside: auto;
      }
    }
  </style>
</head>
<body>
  <div class="header">
    ${headerLines.join('')}
  </div>
  <div class="label-grid">
    ${labelCards}
  </div>
  <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() { window.close(); };
    };
  </script>
</body>
</html>`;

  const win = window.open('', '_blank', 'width=900,height=700');
  if (win) {
    win.document.open();
    win.document.write(html);
    win.document.close();
  } else {
    alert('Popup blocked. Please allow popups for this site.');
  }
}

  close(): void {
    this.dialogref.close();
  }
}